import axios from "axios";

//traigo todos los videojuegos
export function getVideogames(payload){
    return async function(dispatch){
        try{
            var json= await axios(`https://backend-videogames-pi.herokuapp.com/videogames`)
            dispatch({
                type: "GET_GAMES",
                payload: json.data,
            })    
        }catch(error){
            console.log(error);
        }
    }
}  
//ruta donde traemos la informacion por ID, para la info de cada card
export function getVideogamesID(id){
  return async function(dispatch){
    try{
      var json= await axios(`https://backend-videogames-pi.herokuapp.com/videogame/`+id)
      dispatch({
        type:"GET_ID",
        payload:json.data,
      })
    }catch (error) {console.log(error)}
  }
}

//me traigo los generos de mi ruta
export function getAllGenres() {
    return async function (dispatch) {
      try {
        var json = await axios(`https://backend-videogames-pi.herokuapp.com/genres`);
        dispatch({
          type: "GET_ALL_GENRES",
          payload: json.data,
        });
      } catch (error) {
        console.log(error);
      }
    };
  }    

//me traigo las plataformas de mi ruta
export function getAllPlatform(){
  return async function (dispatch) {
    try {
    var json = await axios(`https://backend-videogames-pi.herokuapp.com/platform`);
    dispatch({
      type: "GET_ALL_PLATFORMS",
      payload: json.data,
    });
  } catch (error) {console.log(error)}
}
}

//me traigo la logica para buscar videojuegos
export function getVideogamesbyName(payload){
  return async function (dispatch) {
    try{
      var json = await axios(`https://backend-videogames-pi.herokuapp.com/videogames?name=${payload}`);
      if (!json.data.length) {
        dispatch({
          type: "NO_FOUND_GAME",
          payload: json.data,
        })
      }else{ dispatch({ 
          type: "GET_GAMES_BY_NAME",
          payload: json.data,
        })}
    } catch (error) {console.log(error)};
  }
}
// traigo la informacion de mis videojuegos de mi base de datos getVideogamesbyName
export function infoDeDb(payload){
  return async function (dispatch) {
  try{
    const json = await axios.get(`https://backend-videogames-pi.herokuapp.com/infodb`);
    dispatch({
      type: "INFO_DB",
      payload: json.data,
    })
  }catch (error) {console.log(error)};
  }
}

//ruta del post, donde pasamos la info por query
export function postVideogame(payload){
  return async function (dispatch) {
  try{
    const json = await axios.post(`https://backend-videogames-pi.herokuapp.com/videogames`, payload);
    return json;
  }catch (error) {console.log(error)};
  }
}

//borramos los videojuegos creados

export function deleteVideogames(id) {
  return async function(dispatch){
    try{
        var json= await axios.delete(`https://backend-videogames-pi.herokuapp.com/videogame/`+ id)
        dispatch({
            type: "DELETE_GAME",
            payload: json.data,
        })    
    }catch(error){
        console.log(error);
    }
}
}

//ordenamos de la A-Z y A-Z
export function OrderByName(payload){
  return{
    type:'ORDER_BY_NAME',
    payload,
  }
}
//ordenamos por el valor del rating min y max
export function OrderByRating(payload){
  return{
    type:'ORDER_BY_RATING',
    payload
  }
}
//filtramos por generos
export function filterVideogamesbyGenre(payload) {
    return {
      type: "FILTER_BY_GENRE",
      payload,
    };
  }

//filtramos por creados, api y mostramos todos
export function filterCreated(payload) {
  return {
    type:"FILTER_CREATED",
    payload,
  }
}

export function resetID(payload) {
  return{
    type:"RESET_ID",
    payload,
  }
}